import {container, title, grayColor, secondaryColor} from "../../../nextjs-material-kit.js";
import headerLinksStyle from "../../components/headerLinksStyle.js";

const navbarsStyle = (theme) => ({
  section: {
    padding: "70px 0",
    paddingTop: "0",
  },
  btn: {
    padding: '8px 30px'
  },
  dropDown: {
    backgroundColor: "#406c98",
    fontFamily: "var(--font-brandon-grotesque)",
    textTransform: "capitalize",
    fontSize: "14.5px",
    padding: "3.5px 10px",
    margin: "10px 9px 0px",
    marginLeft: "0px",
    boxShadow: "none !important",
    borderRadius: "0 !important",
    "&:hover": {
      backgroundColor: secondaryColor,
    },
    "&:focus": {
      backgroundColor: secondaryColor,
    },
    "&:active": {
      backgroundColor: secondaryColor,
    },
  },
  container: {
    ...container(theme),
  },
  title: {
    ...title,
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
  },
  navbar: {
    marginBottom: "-20px",
    zIndex: "100",
    position: "relative",
    overflow: "hidden",
    "& header": {
      borderRadius: "0",
    },
  },
  navigation: {
    backgroundPosition: "center center",
    backgroundSize: "cover",
    marginTop: "0",
    minHeight: "740px",
  },
  formControl: {
    [theme.breakpoints.down('lg')]: {
      margin: "10px 0 0 15px !important",
      color: grayColor,
    },
    margin: "10px 0 0 0 !important",
    paddingTop: "0",
  },
  inputRootCustomClasses: {
    margin: "0!important",
  },
  searchIcon: {
    width: "20px",
    height: "20px",
    color: "inherit",
  },
  ...headerLinksStyle(theme),
  img: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
  },
  imageDropdownButton: {
    [theme.breakpoints.down('lg')]: {
      top: "0",
      margin: "5px 15px",
    },
    padding: "0px",
    top: "4px",
    borderRadius: "50%",
    marginLeft: "5px",
  },
});

export default navbarsStyle;
